import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Typography } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

import { palette } from "../../../theme/palette";

import { validateShiftManager } from "../../../utils/shiftManager";

import { selectedShiftManagerSelector } from "../../../reducers/ownApp/selectors";
import {
  sectionsSelector,
  shiftManagerEditSelector,
  shiftManagersSelector,
} from "../../../reducers/shiftManagerManagement/selectors";
import {
  updateShiftManagerEdit,
  setIsShiftManagerEditValid,
} from "../../../reducers/shiftManagerManagement/thunkActions";

import { ShiftManagerManagementModalContent } from "./ShiftManagerManagementModalContent";
import { View } from "../../View";

const useStyles = makeStyles({
  container: {
    flex: 1,
    margin: "0.5%",
    padding: "0 0 0.25% 0",
    maxWidth: "73rem",
    maxHeight: "99%",
    backgroundColor: palette.white,
    borderRadius: "0.4rem",
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    zIndex: 101,
  },
  top: {
    borderRadius: "0.4rem 0.4rem 0rem 0rem",
    backgroundColor: palette.dpdLightGrey,
  },
  title: {
    padding: "1rem 1.6rem",
  },
  bottom: {
    display: "flex",
    marginTop: "0.5rem",
  },
});

export const ShiftManagerManagementModal = () => {
  const styles = useStyles();
  const dispatch = useDispatch();
  const sections = useSelector(sectionsSelector);
  const shiftManagers = useSelector(shiftManagersSelector);
  const shiftManagerEdit = useSelector(shiftManagerEditSelector);
  const selectedShiftManager = useSelector(selectedShiftManagerSelector);
  const selectedShiftManagerCode = (shiftManagerEdit || selectedShiftManager)
    ?.shiftManagerCode;
  const hasSelectedShiftManager = !!selectedShiftManagerCode;
  const [isProcessing, setIsProcessing] = useState(false);

  const errors = validateShiftManager({
    shiftManager: shiftManagerEdit || selectedShiftManager,
    shiftManagers,
    sections,
  });
  const isValid = !Object.keys(errors).length;

  useEffect(() => {
    dispatch(setIsShiftManagerEditValid(isValid));
  }, [isValid, dispatch]);

  const onChange = useCallback(
    async ({ target: { dayOfWeek, name, value } }) => {
      if (isProcessing) return;
      setIsProcessing(true);
      await dispatch(updateShiftManagerEdit({ dayOfWeek, name, value }));
      setIsProcessing(false);
    },
    [dispatch, isProcessing]
  );

  if (!hasSelectedShiftManager) return null;
  else
    return (
      <View className={styles.container}>
        <View className={styles.top}>
          <Typography className={styles.title}>
            {!shiftManagerEdit ? "SHIFT MANAGER DETAILS" : "EDIT SHIFT MANAGER"}
          </Typography>
        </View>
        <View className={styles.bottom}>
          <ShiftManagerManagementModalContent
            sections={sections}
            shiftManager={shiftManagerEdit || selectedShiftManager}
            onChange={onChange}
            disabled={!shiftManagerEdit}
            errors={errors}
          />
        </View>
      </View>
    );
};

export default ShiftManagerManagementModal;
